import { render, staticRenderFns } from "./prodottoSelezionato.vue?vue&type=template&id=99ff2d76&scoped=true&"
import script from "./prodottoSelezionato.vue.ts?vue&type=script&lang=ts&"
export * from "./prodottoSelezionato.vue.ts?vue&type=script&lang=ts&"
import style0 from "./prodottoSelezionato.vue?vue&type=style&index=0&id=99ff2d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff2d76",
  null
  
)

export default component.exports